import React, { useState } from "react";
import { Card, CardBody, Row, Col, Button, CardHeader, Alert } from "reactstrap";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Checkbox } from "react-inputs-validation";
import "../../styles/estilos.css";
import { arraySiniestralidad as siniestro } from 'constants/index.js'
import { Select, Textbox } from "react-inputs-validation";

class CotizacionPymes02 extends React.Component {
  constructor(props) {
    super(props)

    const year = new Date().getFullYear()
    const anios = [{ id: year - 1, name: year - 1 }, { id: year - 2, name: year - 2 }, { id: year - 3, name: year - 3 }]

    this.state = {
      anios1: anios,
      validate: false, estado: false, arraySiniestralidad: [], anios, btnDisabled: false, hasMontoError0: true,
      hasRamoError0: true,
      hasReclamoError0: true,
      hasanioError0: true,
      alert: ''
    }
    this.validateForm = this.validateForm.bind(this);

  }
  componentDidMount() {
    let arrayCoberturas = []
    this.props.arrayCoberturas.forEach(({ codigo: id, nombre: name }) => arrayCoberturas.push({ id, name }))
    this.setState({ arrayCoberturas, })

    console.log('CDM', this.props)

    const { arraySiniestralidad } = this.props
    if (arraySiniestralidad.length > 0)
      this.setState({ arraySiniestralidad, estado: true })
    else
      this.setData(arrayCoberturas)
  }

  setData = (arr) => {

    const { arraySiniestralidad, arrayCoberturas, anios1 } = this.state
    console.log(arr, arrayCoberturas)
    const ramo = arr ? arr[0].id : arrayCoberturas[0].id
    console.log(arrayCoberturas)
    let anios = []

    //    debugger
    if (arraySiniestralidad.length >= 3) {
      for (let i = 0; i < anios1.length; i++) {

        let esTres = 0
        arraySiniestralidad.forEach(({ anio }) => esTres = anios1[i].id === anio ? esTres + 1 : esTres)
        if (esTres < 3)
          anios.push(anios1[i])
      }

    } else anios = anios1

    if (anios.length > 0) {
      const item = { anio: anios[0].id, ramo, numReclamos: 0, monto: 0 }
      arraySiniestralidad.push(item)
      this.setState({ arraySiniestralidad })
    }

  }
  toggleValidating(validate) {
    this.setState({ validate });
  }


  validateForm(e) {
    e.preventDefault();
    const { estado } = this.state
    if (estado) {
      this.toggleValidating(true);
      this.formValidado()
    } else {
      this.props.handleNext({ arraySiniestralidad: [] })
    }
  }
  formValidado = () => {
    const { hasMontoError0, hasRamoError0, hasReclamoError0, hasanioError0, arraySiniestralidad, anios1 } = this.state
    let bandera = true

    if (arraySiniestralidad.length >= 3) {
      for (let i = 0; i < anios1.length; i++) {
        let esTres = 0
        arraySiniestralidad.forEach(({ anio }) => esTres = anios1[i].id === anio ? esTres + 1 : esTres)
        if (esTres > 3)
          bandera = false
      }
    }

    if (bandera) {
      if (!hasMontoError0 && !hasRamoError0 && !hasReclamoError0 && !hasanioError0) {
        console.log('LLL', arraySiniestralidad)
        this.props.handleNext({ arraySiniestralidad })
      }
    }
    else this.setState({ alert: 'Solo puede ingresar 3 items por año' })
  }

  componentDidUpdate(prevProps, prevState) {
    // if (this.props.arraySiniestralidad !== prevProps.arraySiniestralidad) {
    //   this.setData()
    // }
  }


  render() {
    const { estado, arraySiniestralidad, validate, anios, arrayCoberturas, btnDisabled, alert } = this.state

    return (

      <Row>
        <Col xl={10} lg={11} md={12} className="div-align-center">
          <Card>
            <CardHeader> <h4 style={{ fontWeight: 'bold', }} className='mb-5'>Siniestralidad</h4></CardHeader>
            <CardBody>
              {/* <h4 style={{ fontWeight: 'bold', }} className='mb-5'>Ubicación {NumUbicacion}</h4> */}
              <div className="div-align-center" style={{}} >
                <div className='flex' style={{ justifyContent: 'space-between', }}>
                  <h5 style={{ fontWeight: "bold", }}>¿Ha sufrido algún siniestro en los últimos 3 años?</h5>
                  <div className='flex' style={{ flexGrow: 0, }}>
                    <Checkbox
                      id={`preguntaSI`} // Optional.[String].Default: "".  Input ID.
                      name={`preguntaSI`}
                      //value={factotal} // Required.[String].Default: "".
                      onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                      checked={estado} // Required.[Bool].Default: false.
                      onChange={(res, e) => this.setState({ estado: res, validate: false, btnDisabled: true })}
                      labelHtml={<div style={{ color: '#4a4a4a', marginTop: '2px', fontWeight: "bold", }}> SI </div>} // Required.[Html].Default: none.
                      validationOption={{
                        name: 'preguntaSI', // Optional.[String].Default: "". To display in the Error message. i.e Please check the ${name}.
                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                      }}
                    />
                    <Checkbox
                      id={`preguntaNO`} // Optional.[String].Default: "".  Input ID.
                      name={`preguntaNO`}
                      //value={factotal} // Required.[String].Default: "".
                      onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                      checked={!estado} // Required.[Bool].Default: false.
                      onChange={(res, e) => this.setState({ estado: !res, btnDisabled: false })}
                      labelHtml={<div style={{ color: '#4a4a4a', marginTop: '2px', fontWeight: "bold", }}> NO </div>} // Required.[Html].Default: none.
                      validationOption={{
                        name: 'preguntaNO', // Optional.[String].Default: "". To display in the Error message. i.e Please check the ${name}.
                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                      }}
                      style={{ marginLeft: 10, }}
                    />
                  </div> 
                </div>
              </div>

              {estado &&
                <div>


                  <Row>
                    <Col md={12}>
                      <Button className="btn btn-purple" onClick={() => this.setData()} style={{ display: "block" }} >
                        {/* <i className="fa fa-chevron-circle-left" aria-hidden="true" />*/}{"AGREGAR"}
                      </Button>
                    </Col>
                  </Row>
                  <Row >
                    <Col md={3}  > Año</Col> <Col md={4}  >Ramo </Col><Col md={2}  > # Reclamos </Col><Col md={3}  >$ Monto</Col>
                  </Row>
                  {arraySiniestralidad.map((item, i) =>
                    //anio:'',ramo:'', numReclamos:0,monto:0
                    <Row key={'item:' + i} >
                      <Col md={3}  >
                        <Select
                          //tabIndex="4" // Optional.[String or Number].Default: none.
                          id={`selectAnio-${i}`} // Optional.[String].Default: "". Input ID.
                          name={"selectAnio"} // Optional.[String].Default: "". Input name.
                          value={item.anio} // Optional.[String].Default: "".
                          validate={validate}
                          optionList={anios} // Required.[Array of Object(s)].Default: [].
                          onChange={(val, e) => this.setState(({ arraySiniestralidad }) => ({ arraySiniestralidad: [...arraySiniestralidad.slice(0, i), { ...item, anio: parseInt(val) }, ...arraySiniestralidad.slice(i + 1)] }))}
                          validationCallback={res => this.setState({ ['hasanioError' + i]: res, validate: false, btnDisabled: false })}
                          onBlur={() => this.setState({ validate: true })} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          //customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                          validationOption={{
                            name: `selectAnio-${i}`, // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                            msgOnError: "Por favor seleccione un anio"
                          }}
                        />
                      </Col>
                      <Col md={4}  >
                        <Select
                          //tabIndex="4" // Optional.[String or Number].Default: none.
                          id={`selectRamo-${i}`} // Optional.[String].Default: "". Input ID.
                          name={`selectRamo-${i}`} // Optional.[String].Default: "". Input name.
                          value={item.ramo} // Optional.[String].Default: "".
                          validate={validate}
                          optionList={arrayCoberturas} // Required.[Array of Object(s)].Default: [].
                          onChange={(val, e) => this.setState(({ arraySiniestralidad }) => ({ arraySiniestralidad: [...arraySiniestralidad.slice(0, i), { ...item, ramo: val }, ...arraySiniestralidad.slice(i + 1)] }))}
                          validationCallback={res => this.setState({ ['hasRamoError' + i]: res, validate: false, btnDisabled: false })}
                          onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          //customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                          validationOption={{
                            name: `selectRamo-${i}Error`, // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                            msgOnError: "Por favor seleccione un ramo"
                          }}
                        />
                      </Col>
                      <Col md={2}>
                        <Textbox
                          id={`reclamos-${i}`}
                          name={`reclamos-${i}`}
                          type="number"
                          value={item.numReclamos}
                          classNameInput={"form-control"}
                          onChange={(val, e) => this.setState(({ arraySiniestralidad }) => ({ arraySiniestralidad: [...arraySiniestralidad.slice(0, i), { ...item, numReclamos: parseInt(val) }, ...arraySiniestralidad.slice(i + 1)] }))}
                          validationCallback={res => this.setState({ ['hasReclamoError' + i]: res, validate: false, btnDisabled: false })}
                          validate={validate}
                          onBlur={e => { }}
                          validationOption={{
                            name: `reclamos-${i}error`, // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true,
                            type: 'number', // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                            msgOnError: "Por favor ingrese un numero" // Optional.[Bool].Default: true. To determin if it is a required field.
                          }}
                        />
                      </Col>
                      <Col md={3}>
                        <Textbox
                          id={`Monto-${i}`}
                          name={`Monto-${i}`}
                          type="number"
                          value={item.monto}
                          classNameInput={"form-control"}
                          onChange={(val, e) => this.setState(({ arraySiniestralidad }) => ({ arraySiniestralidad: [...arraySiniestralidad.slice(0, i), { ...item, monto: parseFloat(val) }, ...arraySiniestralidad.slice(i + 1)] }))}
                          validationCallback={res => this.setState({ ['hasMontoError' + i]: res, validate: false, btnDisabled: false })}
                          validate={validate}
                          onBlur={e => { }}
                          validationOption={{
                            name: `Monto-${i}error`, // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true,
                            type: 'number', // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                            msgOnError: "Por favor ingrese el monto" // Optional.[Bool].Default: true. To determin if it is a required field.
                          }}
                        />
                      </Col>
                    </Row>
                  )
                  }
                  {alert && <Alert color="danger"> {alert} </Alert>}
                </div>
              }

              <Row>
                <Col lg={6} md={6} sm={6} xs={6} className="mt-3">
                  <Button className="btn btn-detail-gray" onClick={() => this.props.handleBack({})} style={{ display: "block", margin: "auto" }}  >
                    <i className="fa fa-chevron-circle-left" aria-hidden="true" />{"   REGRESAR"}
                  </Button>
                </Col>
                <Col lg={6} md={6} sm={6} xs={6} className="mt-3" >
                  <div className="div-align-rigth">
                    <Button className="btn btn-primary" onClick={this.validateForm} style={{ display: "block", margin: "auto" }} disabled={btnDisabled} >
                      <i className="fa fa-chevron-circle-right" aria-hidden="true" />{` SIGUIENTE UBICACIÓN`} {/* ${NumUbicacion} */}
                    </Button>
                  </div>
                </Col>
              </Row>

            </CardBody>
          </Card>
        </Col>
      </Row >
    )
  }
}

const mapStateToProps = state => ({

});
const mapDispatchToProps = dispatch => {
  return {
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(CotizacionPymes02)
);
